import { Service, ServiceFileDownLoadFiles } from '../Axios/Service'
import qs from "qs";
import store from '../../store';
const PROFILE = {
    plan: 'VUE_APP_PLAN_PREFIX'
}

function getType(apiType) {
  return process.env[PROFILE[apiType]]
}

class Api {
  constructor(ApiType) {
    this.ApiType = ApiType;
  }
  //统计
  planCountryList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/planCountryList`,
      method: "post",
      data,
    });
  }

  listAddImage(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budgetTweet/listAddImage`,
      method: "post",
      data
    });
  }
  //
  customizerCustomerList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/c/link/customizerCustomerList`,
      method: "post",
      data: data
    });
  }
  schemeGenerate
  // 生成地图
  mapAdd(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/map/add`,
      // url: `http://192.168.10.3:9500/wintac-plan-web-test-tw/api/plan/planMapOp`,
      method: "post",
      data: data
    });
  }

  // 地图列表
  mapList(budgetMainId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/map/mapList?budgetMainId=` + budgetMainId,
      // url: `http://192.168.10.3:9500/wintac-plan-web-test-tw/api/plan/planMapOp`,
      method: "get"
    });
  }

  // 删除地图
  mapDeleteMapById(mapId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/map/deleteMapById?mapId=` + mapId,
      // url: `http://192.168.10.3:9500/wintac-plan-web-test-tw/api/plan/planMapOp`,
      method: "get"
    });
  }

  // 选取地图
  selectMap(mapId,budgetMainId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/map/selectMap?mapId=${mapId}&budgetMainId=${budgetMainId}`,
      // url: `http://192.168.10.3:9500/wintac-plan-web-test-tw/api/plan/planMapOp`,
      method: "get"
    });
  }

  //生成行程地图
  planMapOp(budgetMain) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/planMapOp`,
      // url: `http://192.168.10.3:9500/wintac-plan-web-test-tw/api/plan/planMapOp`,
      method: "post",
      data: budgetMain
    });
  }
  //ai智能生成
  aiDistinguish(text, useNumber) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/aiToPlan`,
      method: "post",
      data: qs.stringify({'text': text,'useNumber': useNumber}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  sendPlan(text,jsonStr) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/sendPlan`,
      method: "post",
      data: qs.stringify({'planId': text,'jsonStr':jsonStr}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //word识别
  wordDistinguish(fileObj, useNumber) {
    let apiType = getType(this.ApiType);
    var formData = new FormData();
    formData.append("file", fileObj.raw);
    formData.append("useNumber", Number(useNumber));
    return Service({
      url: `${apiType}/api/plan/wordToPlan`,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  //创建行程
  createTrip(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/createTrip`,
      method: "post",
      data: data
    });
  }
  // 参考酒店导出
  referenceHotelExport(budgetMainId,fileName, fileSuffix,loading) {
    let apiType = getType(this.ApiType);
    ServiceFileDownLoadFiles({
      url: `/${apiType}/api/plan/exportReferenceHotel`,
      method: "post",
      data: qs.stringify({ budgetMainId: budgetMainId}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    }).then(res => {
      let fileTypeMime = '' // 文件 mime 类型，移动端必传，否则下载不成功；pc端可传可不传
      switch (fileSuffix) { // 获取后缀对应的 mime
        case 'png':
          fileTypeMime = 'image/png';
          break;
        case 'doc' || 'pdf':
          fileTypeMime = 'application/msword';
          break;
        case 'docx' || 'pdf':
          fileTypeMime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case 'jpg':
        case 'jpeg':
          fileTypeMime = 'image/jpeg';
          break;
        case 'gif':
          fileTypeMime = 'image/gif';
          break;
        case 'svg':
          fileTypeMime = 'image/svg+xml';
          break;
        case 'tif':
        case 'tiff':
          fileTypeMime = 'image/tiff';
          break;
        case 'txt':
          fileTypeMime = 'text/plain';
          break;
        case 'ppt':
          fileTypeMime = 'application/vnd.ms-powerpoint';
          break;
        case 'pptx':
          fileTypeMime = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        case 'xls':
          fileTypeMime = 'application/vnd.ms-excel';
          break;
        case 'xlsx':
          fileTypeMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case 'zip':
          fileTypeMime = 'application/zip';
          break;
        case '7z':
          fileTypeMime = 'application/x-7z-compressed';
          break;
      }
      const myblob = new Blob([res.data]);
      if ('download' in document.createElement('a')) {
        let blob = window.URL.createObjectURL(myblob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = blob
        link.setAttribute('download', fileName + fileSuffix)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(blob) //释放掉 blob 对象
        }, 1000);
      }
      else {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, fileName + fileSuffix);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);
          window.location = downloadUrl;
        }
      }
      if(loading) loading.close()
    })
  }

  // 获取导出的项目预算单文件名
  getPlanBudgetName(budgetMainId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/plan/getName?budgetMainId=${budgetMainId}`,
      method: "get"
    });
  }
  //导出行程
  exportPlanToWord(budgetMainId,schemeId, fileName,itemFileType,checkItemContent, fileSuffix,callback) {
    let apiType = getType(this.ApiType);
    ServiceFileDownLoadFiles({
      url: `/${apiType}/api/plan/exportPlan`,
      // url: `http://localhost:9500/wintac-plan-web-test-tw/api/plan/exportPlan`,
      method: "post",
      data: qs.stringify({ budgetMainId: budgetMainId,programmeId: schemeId,itemFileType: itemFileType,checkItemContent: JSON.stringify(checkItemContent)}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    }).then(res => {
      let fileTypeMime = '' // 文件 mime 类型，移动端必传，否则下载不成功；pc端可传可不传
      switch (fileSuffix) { // 获取后缀对应的 mime
      case 'png':
        fileTypeMime = 'image/png';
        break;
      case 'doc' || 'pdf':
        fileTypeMime = 'application/msword';
        break;
      case 'docx' || 'pdf':
        fileTypeMime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case 'jpg':
      case 'jpeg':
        fileTypeMime = 'image/jpeg';
        break;
      case 'gif':
        fileTypeMime = 'image/gif';
        break;
      case 'svg':
        fileTypeMime = 'image/svg+xml';
        break;
      case 'tif':
      case 'tiff':
        fileTypeMime = 'image/tiff';
        break;
      case 'txt':
        fileTypeMime = 'text/plain';
        break;
      case 'ppt':
        fileTypeMime = 'application/vnd.ms-powerpoint';
        break;
      case 'pptx':
        fileTypeMime = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case 'xls':
        fileTypeMime = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        fileTypeMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'zip':
        fileTypeMime = 'application/zip';
        break;
      case '7z':
        fileTypeMime = 'application/x-7z-compressed';
        break;
      }
      const myblob = new Blob([res.data]);
      if ('download' in document.createElement('a')) {
        let blob = window.URL.createObjectURL(myblob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = blob
        link.setAttribute('download', fileName + fileSuffix)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(blob) //释放掉 blob 对象
        }, 1000);
      }
      else {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, fileName + fileSuffix);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);
          window.location = downloadUrl;
        }
      }
      // loading.close()
      callback(true)
    })
  }
   //参考酒店列表
   referenceHotelList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/referenceHotelList`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //参考酒店数据修改
  referenceHotelDataUpdate(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/referenceHotelDataUpdate`,
      method: "post",
      data: data,
    });
  }
  //行程详情
  planDetail(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/planDetail`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //行程列表
  planList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/planList`,
      method: "post",
      data: data
    });
  }
  //方案分享列表
  planSharList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/sharePlanList`,
      method: "post",
      data: data
    });
  }
  //行程库列表
  sysPlanList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/sysPlanList`,
      method: "post",
      data: data
    });
  }
  //回收站列表
  recoveryPlanList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/recoveryPlanList`,
      method: "post",
      data: data
    });
  }
  //回收站数据恢复
  restorePlan(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/restorePlan`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  removeRecoveryPlan(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/removeRecoveryPlan`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //新曾城市节点接口
  addPlanCity(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/addPlanCity`,
      method: "post",
      data: data
    });
  }
  //大交通数据新增
  addBigTraffic(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/addBigTraffic`,
      method: "post",
      data: data
    });
  }
  saveBudgetMain(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/saveBudgetMain`,
      method: "post",
      data: data
    });
  }
  updateCityTrafficType(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/updateCityTrafficType`,
      method: "post",
      data: data
    });
  }
  addList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/addList`,
      method: "post",
      data: data
    });
  }
  linkBudgetList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/linkBudgetList`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  budgetEmpty(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/budgetEmpty`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  linkList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/linkList`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //删除城市节点接口
  delPlanCity(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/delPlanCity`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
   //删除城市节点接口
   planLinkInquiry(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/planLinkInquiry`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //删除行程天
  delPlanDay(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/delPlanDay`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //前加后加一天
  addBeforeDay(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/addBeforeDay`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //预算单修改时间弹框数据查询接口
  changeTimeBudgetlist(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/changeTimeBudgetlist`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  deleteBudgetFile(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/deleteBudgetFile`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  uploadBudgetFile(formData) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `${apiType}/api/budget/uploadBudgetFile`,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  //预算单报价弹框数据查询接口
  budgetDetailList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/budgetDetailList`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //预算单报价弹框数据查询接口
  oneBudgetDetailList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/oneBudgetDetailList`,
      method: "post",
      data: data
    });
  }

  //预算单报价复制
  budgetCopy(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/budgetCopy`,
      method: "post",
      data: data
    });
  }

  //预算单报价编辑
  budgetEdit(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/budgetEdit`,
      method: "post",
      data: data
    });
  }

  //预算单报价删除
  budgetRemove(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/budgetRemove`,
      method: "post",
      data: data
    });
  }

  //预算单修改天数
  changeBudgetStayDate(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/changeBudgetStayDate`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //设置行程其他人可见
  updatePlan(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/updatePlan`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //预算单报价弹框数据查询接口
  sysBudgetDetailList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/sysBudgetDetailList`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //预算单报价弹框数据查询接口
  addPlanViewNumber(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/addViewNumber`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //预算单修改时间弹框数据保存接口
  updateBudget(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/updateBudget`,
      method: "post",
      data: data
    });
  }
  changeCitySort(data){
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/updateCitySort`,
      method: "post",
      data: data
    });
  }
  chooseOtherTrip(data){
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/chooseOtherTrip`,
      method: "post",
      data: data
    });
  }
  //删除行程数据接口
  delPlan(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/plan/delPlan`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //修改预算详情数据接口
  updateBudgetDetail(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/updateBudgetDetail`,
      method: "post",
      data: data
    });
  }
  //申请加入形成库
  applySysPlan(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/applySysPlan`,
      method: "post",
      data: data
    });
  }

  obtainSchemeInformation(budgetMainId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/obtainSchemeInformation`,
      method: "post",
      data: qs.stringify({id: budgetMainId}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  sysList(budgetMainId) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/sysList`,
      method: "post",
      data: qs.stringify({budgetMainId: budgetMainId}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //保存方案
  updateBudgetMain(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/updateBudgetMain`,
      method: "post",
      data: data
    });
  }
  //新增预算数据接口
  budgetAdd(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/add`,
      method: "post",
      data: data
    });
  }

    //特推图列表
    tweetImage(ids) {
      let apiType = getType(this.ApiType);
      return Service({
        url: `/${apiType}/api/budgetTweet/list`,
        method: "post",
        data: ids,
      });
    }

     //特推图列表
     listText(ids) {
      let apiType = getType(this.ApiType);
      return Service({
        url: `/${apiType}/api/budgetTweet/listText`,
        method: "post",
        data: ids,
      });
    }

     //特推图列表
     addBudgetTweet(ids) {
      let apiType = getType(this.ApiType);
      return Service({
        url: `/${apiType}/api/budgetTweet/uploadBudgetImage`,
        method: "post",
        data: ids,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    //新增预算单关联特推图数据
    tweetImageAdd(ids) {
      let apiType = getType(this.ApiType);
      return Service({
        url: `/${apiType}/api/budgetTweet/add`,
        method: "post",
        data: ids,
      });
    }


  //新增预算数据接口
  addBudgetRefer(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/addBudgetRefer`,
      method: "post",
      data: data
    });
  }
  //预算单中间数据查询
  budgetList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/list`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //预算单中间数据删除
  budgetDelete(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/budget/deleteBudget`,
      method: "post",
      data: data,
    });
  }
  //报价说明新增修改
  saveOrUpdateQuoted(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/saveOrUpdateQuoted`,
      method: "post",
      data: data,
    });
  }

  updateDescById(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/updateDescById`,
      method: "post",
      data: data,
    });
  }

  schemeDelById(id) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/schemeDelById?schemeId=${id}`,
      method: "get"
    });
  }

  savaOrUpdateDesc(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/savaOrUpdateDesc`,
      method: "post",
      data: data,
    });
  }
  //报价说明查询列表
  queryByCompanyId(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/queryByCompanyId`,
      method: "post",
      data: qs.stringify({exportType: data}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  dragAndDropModification(dataList) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/dragAndDropModification`,
      method: "post",
      data: dataList,
    });
  }

  //拖拽交换排序位置
  dragAndDrop(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/dragAndDrop`,
      method: "post",
      data: data,
    });
  }
   //根据ID 删除子项数据
   delDescById(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/delDescById?id=${data}`,
      method: "get"
    });
  }
   //根据ID 修改名称
   updateDescById(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/updateDescById`,
      method: "post",
      data: data,
    });
  }
  //报价说明默认按钮
  queryOption(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/quoted/queryOption`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
}

export default Api;
